import { defineComponent, ref } from '@vue/composition-api';
export default defineComponent({
    name: 'DpLegendLabel',
    props: {
        item: { type: Object, default: () => ({}) },
    },
    setup(_, { emit }) {
        const isDisabled = ref(false);
        const toggleItem = (item) => {
            isDisabled.value = !isDisabled.value;
            const emitting = isDisabled.value ? 'disable-item' : 'enable-item';
            emit(emitting, item);
        };
        return {
            isDisabled,
            toggleItem,
        };
    },
});
